var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiDestination(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 3816.3,
    height: 2639.8,
    viewBox: "0 0 3816.3 2639.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DOORS"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1266.7,
    y: 3,
    width: 1306,
    height: 1234.3,
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1266.7,
    y: 3,
    width: 653,
    height: 1234.3,
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1919.7,
    y: 3,
    width: 653,
    height: 1234.3,
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2054,
    y: 122.4,
    width: 398.2,
    height: 398.2,
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2314.1,
    y1: 313.9,
    x2: 2267.8,
    y2: 348.9,
    fill: "none",
    stroke: "#66b0f0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "2203.3 397.7 2054 510.6 2054 427.6 2452.1 132.4 2452.1 209.6 2344.8 290.7",
    fill: "none",
    stroke: "#66b0f0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1266.7 3 1919.7 3 1919.7 98.5 1266.7 3",
    fill: "#66b0f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2082.8,791.9h0a12.68,12.68,0,0,1-11-6.4l-95.5-167a12.73,12.73,0,0,1,11-19h0a12.68,12.68,0,0,1,11,6.4l95.5,167A12.71,12.71,0,0,1,2082.8,791.9Z",
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1385.6,
    y: 122.4,
    width: 398.2,
    height: 398.2,
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1385.6,
    y1: 427.6,
    x2: 1783.7,
    y2: 132.4,
    fill: "none",
    stroke: "#66b0f0",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1754.9,791.9h0a12.68,12.68,0,0,0,11-6.4l95.5-167a12.73,12.73,0,0,0-11-19h0a12.68,12.68,0,0,0-11,6.4l-95.5,167A12.71,12.71,0,0,0,1754.9,791.9Z",
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "STAIRS"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "3594.1 2438.8 230 2628.8 230 2358.5 3594.1 2358.5 3594.1 2438.8",
    fill: "#d0f0e4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "3440.8 2149 404.6 2339 404.6 2068.7 3440.8 2068.7 3440.8 2149",
    fill: "#d0f0e4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "3245.3 1860.2 568.5 2050.2 568.5 1779.9 3245.3 1779.9 3245.3 1860.2",
    fill: "#d0f0e4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "3091.2 1573.4 751.1 1763.4 751.1 1493.1 3091.2 1493.1 3091.2 1573.4",
    fill: "#d0f0e4"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "230 2358.5 3594.1 2358.5 3594.1 2618.8",
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "404.6 2067.7 3440.8 2067.7 3440.8 2339.1",
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "568.5 1778.9 3245.3 1778.9 3245.3 2050.2",
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "752.1 1492.1 3091.2 1492.1 3091.2 1763.4",
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2881.2 1302.4 961.2 1468.9 961.2 1232 2881.2 1232 2881.2 1302.4",
    fill: "#d0f0e4"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "962 1231.1 2881.2 1231.1 2881.2 1468.9",
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 751.3,
    y1: 1774.6,
    x2: 751.3,
    y2: 1150.4,
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1268,726.9,93.5,1689a219.05,219.05,0,0,0-64.2,154.9h0c0,121,98.1,224.1,219.1,224.1",
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 401.6,
    y1: 2339.1,
    x2: 401.6,
    y2: 1436,
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3091.2,
    y1: 1776.6,
    x2: 3091.2,
    y2: 1150.4,
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2574.5,726.9,3749.1,1689a219.05,219.05,0,0,1,64.2,154.9h0c0,121-98.1,224.1-219.1,224.1",
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3441,
    y1: 2339.1,
    x2: 3441,
    y2: 1436,
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "PLANTS"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3281.5,2634.3s130.9-234.9,51.4-236.2c-37.1-.6-75.1,126.5-60.7,236.2Z",
    fill: "#3fb1b5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3275.8,2633s48.6-219.9,166-184.4-83,184.4-83,184.4",
    fill: "none",
    stroke: "#ffcf2d",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3118.7,2636.8c-40.7-3.8-63.7-76.6-15.5-100.9,69.3-34.9,91,38,77.3,40.4s-33-89.7,26.8-87.2,62,143.9,62,143.9",
    fill: "none",
    stroke: "#ffcf2d",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3325,2633s62.5-151.8,123.4-182.1",
    fill: "none",
    stroke: "#ffcf2d",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3258.4,2554.2s-14.7-81.5-15.3-135.1",
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3276.2,2455.4c-2.9,7.2-25.3,25.1-25.3,25.1s-3.6-28.5-.7-35.7a14,14,0,0,1,26,10.6Z",
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3268.7,2398.1c-2.9,7.2-25.3,25.1-25.3,25.1s-3.6-28.5-.7-35.7a14,14,0,0,1,18.2-7.7A14.11,14.11,0,0,1,3268.7,2398.1Z",
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3217.1,2461.7c4.2,6.5,29.6,19.8,29.6,19.8s-1.9-28.6-6.1-35.1a14,14,0,1,0-23.5,15.3Z",
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.1,2638.4s-80.4-72.6-78.8-124.7c1.8-59.6,58.8-30.8,61.8-52.3s-60.2-167.8,27.9-166.7,47.1,141.5,71,154.5,63.5-2.5,52.8,54.3-99.7,134.2-99.7,134.2Z",
    fill: "#3fb1b5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.7,2636.6c-52.1,0-92.2-95.2-11.9-120.4s89.1,50.7,71.6,53.6S163.2,2424,307.7,2444.2c157.7,22,61.3,192.4,61.3,192.4s93-156.4,7.5-339.6",
    fill: "none",
    stroke: "#ffcf2d",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.2,2636.6s81.6-170.8,159.9-116.4-105.5,116.4-105.5,116.4",
    fill: "none",
    stroke: "#ffcf2d",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.6,2635.1s79.3-106,131.6-113.8",
    fill: "none",
    stroke: "#ffcf2d",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.5,2635.6s42.9-99.9,80.9-159.1",
    fill: "none",
    stroke: "#ffcf2d",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.5,2540.1c-8.4,5.8-45.9,9.3-45.9,9.3s16.7-33.8,25-39.6a18.4,18.4,0,1,1,20.9,30.3Z",
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.7,2471.9c-8.4,5.8-45.9,9.3-45.9,9.3s16.7-33.8,25-39.6a18.4,18.4,0,0,1,20.9,30.3Z",
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.6,2414c-5.4,8.6-38.5,26.6-38.5,26.6s1.9-37.6,7.4-46.2a18.38,18.38,0,1,1,31.1,19.6Z",
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.1,2504.3c-.1,10.2,18.1,43.2,18.1,43.2s18.6-32.8,18.7-42.9a18.4,18.4,0,0,0-36.8-.3Z",
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.3,2436.9c-.1,10.2,18.1,43.2,18.1,43.2s18.6-32.8,18.7-42.9a18.4,18.4,0,0,0-36.8-.3Z",
    fill: "none",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2865.9,
    y1: 2636.8,
    x2: 3708.7,
    y2: 2636.8,
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    y1: 2636.8,
    x2: 2033.4,
    y2: 2636.8,
    fill: "none",
    stroke: "#66b0f0",
    strokeMiterlimit: 10,
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "_3_CHARACTER",
    "data-name": "3 CHARACTER"
  }, /*#__PURE__*/React.createElement("g", {
    id: "JACKET"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1848.4,716.9a86.21,86.21,0,0,1-2,18.3l-.9,3.6a84.29,84.29,0,0,1-17.3,33.1c-.1.1-.2.3-.3.4-.9,1.1-1.9,2.1-2.9,3.2a4.62,4.62,0,0,1-.7.7,86.46,86.46,0,0,1-33.1,21.1l-3.6,1.2a84.5,84.5,0,0,1-33.1,3c-1.2-.1-2.4-.3-3.6-.5a84.85,84.85,0,0,1-33.1-12.4l-3.6-2.4a82.78,82.78,0,0,1-12.3-10.7c-1.1-1.2-2.2-2.3-3.2-3.6a79.44,79.44,0,0,1-6-8l-6.3-9.5,5.6,17.5,1.1,3.6,10.5,33.1,1.1,3.6,9.5,30,1,3.1,1.1,3.6,1.5,4.6,9,28.5,1.1,3.6,10.5,33.1,1.1,3.6,10.5,33.1.8,2.6.3,1,3.3,10.3.6,1.9a3.38,3.38,0,0,0-.6-1.2,8.91,8.91,0,0,0-3.6-2.7c-5.7-2.8-17.1-4.9-33.1-6.1l-3.6-.3c-9.6-.6-20.6-1-33.1-1.2h-3.6c-10.2-.1-21.2,0-33.1.3-1.2,0-2.4.1-3.6.1-10.5.3-21.5.7-33.1,1.2-1.2.1-2.4.1-3.6.2-10.6.5-21.6,1.1-33.1,1.8-1.2.1-2.4.1-3.6.2-10.7.7-21.7,1.4-33.1,2.3l-3.6.3c-10.8.8-21.8,1.7-33.1,2.7l-3.3.3h-.3c-11.2,1-22.3,2-33.1,3.1-1.2.1-2.4.2-3.6.4-11.3,1.1-22.4,2.3-33.1,3.6-1.2.1-2.4.3-3.6.4-11.4,1.3-22.5,2.7-33.1,4.2-1.2.2-2.4.3-3.6.5-11.6,1.6-22.6,3.2-33.1,4.8l-3.6.6c-11.4,1.8-22,3.7-31.9,5.5a5,5,0,0,1-1.2.2c-1.2.2-2.4.5-3.6.7q-6.75,1.35-12.9,2.7c-7.4,1.6-14.1,3.2-20.2,4.8-1.2.3-2.4.6-3.6,1-21,5.7-32.9,11.3-32.9,16.3V874.3H1130.5c-1.2,0-2.4,0-3.6-.1a112.91,112.91,0,0,1-33.1-6.2c-1.2-.4-2.4-.9-3.6-1.3a114,114,0,0,1-30-17.5c-1-.8-2.1-1.7-3.1-2.6a10,10,0,0,1-1.1-1c-.8-.7-1.7-1.5-2.5-2.3-.7-.6-1.3-1.3-2-2a111.21,111.21,0,0,1-20.9-28.9c-.6-1.2-1.2-2.4-1.7-3.6a108.71,108.71,0,0,1-9.4-33.1c-.2-1.2-.3-2.4-.4-3.6-.3-3.4-.5-6.8-.5-10.3a115.25,115.25,0,0,1,2.3-22.8c.2-1.2.5-2.4.8-3.6a112,112,0,0,1,13.9-33.1c.6-.9,1.2-1.9,1.8-2.8l.5-.8,15.5-23.3,3.6-5.4,3-4.4,2.4-3.6,22.1-33.1,2.4-3.6,3.3-4.9,3.6-5.4,15.2-22.8,2.4-3.6,15.5-23.3,3.6-5.4,2.9-4.4,2.4-3.6,22.1-33.1,2.4-3.6.6-.9c.9-1.3,1.8-2.5,2.7-3.8,1.2-1.6,2.4-3.1,3.6-4.7a154.31,154.31,0,0,1,23.4-23.7l4.5-3.6c1.7-1.3,3.5-2.6,5.2-3.8l3.6-2.4a158.55,158.55,0,0,1,33.1-16.8c1.2-.4,2.4-.9,3.6-1.3a155.71,155.71,0,0,1,33.1-7.5c1.2-.1,2.4-.3,3.6-.4,5-.5,10.1-.7,15.2-.7h280.3l.3-.1,9.2-3.6,21.6-8.4,3.6-1.4,33.1-12.9,3.6-1.4,23.3-9,9.2-3.6.6-.3,3.6-1.4,6.2-2.4,2.2,4.1,2,3.6,18.1,33.1,2,3.6,2.6,4.8,3.6,6.6,11.9,21.7,2,3.6,18.1,33.1,1.1,2.1.8,1.5,2.8,5,15.3,28.1,2,3.6,15.8,28.9,2.3,4.2,1.3,2.3.7,1.3,18.1,33.1,2,3.6,12.3,22.5,3.6,6.6,2.2,4,2,3.6,5.9,10.8a86.45,86.45,0,0,1,8.4,22.3c.3,1.2.5,2.4.7,3.6A63.17,63.17,0,0,1,1848.4,716.9Z",
    fill: "#fe5244"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1057.5,669.9V846.3a10,10,0,0,1-1.1-1c-.8-.7-1.7-1.5-2.5-2.3V675.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1130.9,559.8V874c-1.2,0-2.4,0-3.6-.1V565.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094.2,614.8V867.6c-1.2-.4-2.4-.9-3.6-1.3V620.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1204.3,472.1V873.9h-3.6V474.6C1201.9,473.8,1203.1,472.9,1204.3,472.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1167.6,505.7V873.9H1164V510.4C1165.2,508.8,1166.4,507.3,1167.6,505.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1277.7,446.2v554.2c-1.2.3-2.4.6-3.6,1V446.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1241,454.1V874h-3.6V455.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1314.3,445.3V992.2c-1.2.2-2.4.5-3.6.7V445.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387.7,445.3V980.6c-1.2.2-2.4.3-3.6.5V445.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1351,445.3V985.9l-3.6.6V445.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1461.1,445.3V972.1c-1.2.1-2.4.2-3.6.4V445.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1424.4,445.3V976c-1.2.1-2.4.3-3.6.4V445.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1534.5,445.3V965.7l-3.6.3V445.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1497.8,445.3V968.7l-3.3.3h-.3V445.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1571.1,445.3v518c-1.2.1-2.4.1-3.6.2V445.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1644.5,417.7V960.1c-1.2,0-2.4.1-3.6.1V419.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1607.8,431.9V961.3c-1.2.1-2.4.1-3.6.2V433.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1717.9,456.7V788.6l-3.6-2.4v-336Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1717.9,853.5V961.2l-3.6-.3V842.1l1,3.1,1.1,3.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1681.2 402.9 1681.2 403.4 1677.6 404.8 1677.6 402.9 1681.2 402.9",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1681.2,403.4V959.8h-3.6v-555Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1791.3,590.8V797.3l-3.6,1.2V584.3l2.3,4.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1754.6,969.3v.8a8.91,8.91,0,0,0-3.6-2.7V958l.3,1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1754.6,523.7V801.4c-1.2-.1-2.4-.3-3.6-.5V517.2l.8,1.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1827.9,657.8V772.3c-.9,1.1-1.9,2.1-2.9,3.2a4.62,4.62,0,0,1-.7.7V651.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1315.6,992a5,5,0,0,1-1.2.2c-1.2.2-2.4.5-3.6.7q-6.75,1.35-12.9,2.7H1241V992Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1739.7 922.2 1241 922.2 1241 918.6 1738.5 918.6 1739.7 922.2",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1751.3 958.9 1241 958.9 1241 955.3 1750.2 955.3 1751 957.9 1751.3 958.9",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1728 885.5 1241 885.5 1241 882 1726.9 882 1728 885.5",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1704.8,812.2H1031.1c-.6-1.2-1.2-2.4-1.7-3.6h674.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1716.4,848.9H1060.6c-1-.8-2.1-1.7-3.1-2.6a10,10,0,0,1-1.1-1h658.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1846.5,735.2l-.9,3.6H1021.4c.2-1.2.5-2.4.8-3.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693.2,775.5H1019.9c-.2-1.2-.3-2.4-.4-3.6H1692Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1828.3,771.9c-.1.1-.2.3-.3.4-.9,1.1-1.9,2.1-2.9,3.2H1702c-1.1-1.2-2.2-2.3-3.2-3.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1832.1 665.4 1060.5 665.4 1062.9 661.8 1830.1 661.8 1832.1 665.4",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1847.1,702.1h-811c.6-.9,1.2-1.9,1.8-2.8l.5-.8h808C1846.7,699.7,1846.9,700.9,1847.1,702.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1812 628.7 1085 628.7 1087.3 625.2 1810.1 625.2 1812 628.7",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1771.9 555.4 1133.8 555.4 1136.2 551.8 1769.9 551.8 1771.9 555.4",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1792 592.1 1109.4 592.1 1111.8 588.5 1790 588.5 1791.3 590.8 1792 592.1",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1731.7,482H1190.9l4.5-3.6h534.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1751.8 518.7 1158.3 518.7 1160.7 515.1 1749.8 515.1 1751 517.2 1751.8 518.7",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1691.6 408.6 1667.8 408.6 1677 405 1689.6 405 1691.6 408.6",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1711.7 445.3 1573.5 445.3 1582.7 441.7 1709.7 441.7 1711.7 445.3",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1503.3,1041.7c-169.2,13.1-262-2.9-262.1-24.1h0c0-15.2,111.7-36.3,253.3-48.6,149.5-12.9,256.1-12.3,260.7,2.2C1761.6,991.4,1678.5,1028.1,1503.3,1041.7Z",
    fill: "#e57281"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1495.4,
    y1: 847.1,
    x2: 1553,
    y2: 964.4,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1476.3,
    cy: 884,
    r: 8.9,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1573.2,
    y1: 445.4,
    x2: 1698.8,
    y2: 781.1,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019.5,744.3c25.4-14.7,62,1.1,81.7,35.3s15.1,73.7-10.3,88.4",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1845.3,739.8a84.84,84.84,0,0,1-110.9,56.9c-5.7-22.4,10.9-49.2,39.9-62.7C1801.1,721.6,1830.1,724.6,1845.3,739.8Z",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1495.4,
    y1: 966.7,
    x2: 1494.2,
    y2: 445.3,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1524.7,
    cy: 554.1,
    r: 8.9,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1524.7,
    cy: 663.9,
    r: 8.9,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1524.7,
    cy: 773.7,
    r: 8.9,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "1365.1 443.6 1495 518.1 1564.2 442.7",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "LEGS"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RIGHT"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "1797.7 1780.5 1566.5 1780.6 1582 1731.1 1796.7 1731.1 1797.7 1780.5",
    fill: "#fff",
    stroke: "#fe5244",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1851.7,1208.1a256.58,256.58,0,0,1,28.7,197.3l-74.8,287.3-10,38.4H1582.1l15.8-50.3,88.9-288.1L1432.3,975.1c19.8-2.2,40.6-4.3,62.1-6.1,88.2-7.6,161.4-10.5,207.6-8.7Z",
    fill: "#fff",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "LEFT"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2108.5,1780.5l-310.8.1-1-49.8.2.3,171-79.3c96.5,29.9,138.2,73.4,155.8,101.4A17.88,17.88,0,0,1,2108.5,1780.5Z",
    fill: "#fff",
    stroke: "#fe5244",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1967.9,1651.8l-171,79.3-454.6-622.2A253.18,253.18,0,0,1,1296.1,996c46.1-10.1,117.4-20,198.4-27q30.6-2.7,58.5-4.5l40.6,67.2Z",
    fill: "#fff",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1467.2,
    y1: 1028.9,
    x2: 1868.6,
    y2: 1694,
    fill: "none",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1438.8,1003.1s-3,73.4-66.4,99.3",
    fill: "none",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("path", {
    id: "SHADOW",
    d: "M1702.1,960.3l23,38.2c-26.5,11.8-70.2,24-131.6,33.1-26.7,4-56.8,7.4-90.3,10-16.9,1.3-33,2.3-48.3,3.1-62.4,3.1-112,1.7-147.6-2.4A252.35,252.35,0,0,1,1296,996s99.9-19,203.1-27.4S1702.1,960.3,1702.1,960.3Z",
    fill: "#9a3b82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1238.5,1018.5c0-15.2,107.3-37.4,256-50.4,149.5-13.1,258.8-11.4,263.4,3.1",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "HEAD"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NECK"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "1504.8 445.4 1370.5 445.4 1389 347.9 1504.8 347.9 1504.8 445.4",
    fill: "#ffcf2d"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1403.9 445.4 1370.5 445.4 1389 347.9 1504.8 347.9 1504.8 382.3 1403.9 445.4",
    fill: "#e57281"
  })), /*#__PURE__*/React.createElement("path", {
    id: "HAIR",
    d: "M1388.5,362.5s18.4-104.6,20.8-110.5c4.1-10,88.8-42.2,101.8-30.3s-13.3,22.5.8,21.4,56.6-32.7,74.4-8.6c10.8,14.7-24,35.9-46.3,40.2s-85,37.9-86.5,49.8S1431.9,360.2,1388.5,362.5Z",
    fill: "#fff",
    stroke: "#ffcf2d",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("g", {
    id: "HEAD-2",
    "data-name": "HEAD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1540,272.9v88.6a24.9,24.9,0,0,1-24.9,24.9h-31.7a29.83,29.83,0,0,1-29.8-29.9v-8.7h-15.4a18.1,18.1,0,0,1,0-36.2h17.4a42.18,42.18,0,0,1,32.2-28.6Z",
    fill: "#ffcf2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1450,333.6c0-8.2-4.9-14.3-13-13",
    fill: "none",
    stroke: "#e57281",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1507.4,305s10.4-5.9,22.1-7",
    fill: "none",
    stroke: "#e57281",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1521.8,
    cy: 317.8,
    rx: 4,
    ry: 6.5,
    fill: "#e57281"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ARMS"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LEFT-2",
    "data-name": "LEFT"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1444.6,764l-23.6,9-2.1.8-16.2,6.1V735.3H1206.8l43.6-74.1,1.8-3.1,21.5-8.1,4.2-1.6,16.5-6.3,3.2-1.2,25.4-9.7,4.2-1.6h0l16.2-6.1,4-1.5,17.4-6.6a5.64,5.64,0,0,1,1.2-.4,18,18,0,0,1,3.9-.8,24.79,24.79,0,0,1,4.7-.1,21.88,21.88,0,0,1,18.3,14Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1414.3,677.8l-19.1-50.5a23.88,23.88,0,0,0-20.7-15.4,23.31,23.31,0,0,0-5.3.2,21.66,21.66,0,0,0-5,1.3l-17.4,6.6-4.2,1.6-16,6.1-4.2,1.6-25,9.5-4.2,1.6-16.1,6.1-4.2,1.6-18.9,7.2-1.8,3.1-1.8,3.1,24.3-9.2,4.2-1.6,45.1-17.1,4.2-1.6,36.1-13.7,1.3-.5,1.8-.6a21.36,21.36,0,0,1,3.5-.6c.6,0,1.1-.1,1.7-.1a19.68,19.68,0,0,1,18.4,12.7L1441.7,763l-19.5,7.4-2.1.8-2.1.8-15.4,5.8v4.8l17-6.4,27.8-10.6h0Z",
    fill: "#3fb1b5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1444.6,764l-23.7,9-54.8-144.5a12.64,12.64,0,0,1,7.3-16.3h0a12.64,12.64,0,0,1,16.3,7.3Z",
    fill: "#3fb1b5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1419.6,775.8,1364,629.2a14.91,14.91,0,0,1,20-18.9,14.79,14.79,0,0,1,7.8,8.3l55.6,146.6ZM1378,613.6a9.71,9.71,0,0,0-3.7.7,10.31,10.31,0,0,0-6,13.4l54,142.4,19.5-7.4-54-142.4a10.12,10.12,0,0,0-5.5-5.8A11.06,11.06,0,0,0,1378,613.6Z",
    fill: "#3fb1b5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1338,643.7a13.05,13.05,0,0,1-7.4-2.6,22.76,22.76,0,0,1-7.8-10.5,22.15,22.15,0,0,1-1.1-13.1c1-4.3,3.5-7.4,6.9-8.7,6.9-2.6,15.1,2.9,18.7,12.5a2.25,2.25,0,1,1-4.2,1.6c-2.7-7-8.6-11.5-13-9.9-2,.8-3.5,2.7-4.1,5.5a18.15,18.15,0,0,0,1,10.4,19,19,0,0,0,6.2,8.5c2.4,1.7,4.8,2.2,6.8,1.4a2.25,2.25,0,1,1,1.6,4.2A9.22,9.22,0,0,1,1338,643.7Z",
    fill: "#3fb1b5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1288.3,661.8a13.05,13.05,0,0,1-7.4-2.6,22.76,22.76,0,0,1-7.8-10.5,22.15,22.15,0,0,1-1.1-13.1c1-4.3,3.5-7.4,6.9-8.7s7.3-.6,10.9,1.9a22.76,22.76,0,0,1,7.8,10.5,2.25,2.25,0,0,1-4.2,1.6,19,19,0,0,0-6.2-8.5c-2.4-1.7-4.8-2.2-6.8-1.4s-3.5,2.7-4.1,5.5a18.15,18.15,0,0,0,1,10.4,19,19,0,0,0,6.2,8.5c2.4,1.7,4.8,2.2,6.8,1.4a2.25,2.25,0,1,1,1.6,4.2A7.84,7.84,0,0,1,1288.3,661.8Z",
    fill: "#3fb1b5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1402.9,
    cy: 804.6,
    rx: 25.4,
    ry: 69.3,
    fill: "#73325a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1494.1,749.5v75a17.49,17.49,0,0,1-8.2,14.8l-32,19h-67.2c-5.7-12.7-9.3-32-9.3-53.5a162.94,162.94,0,0,1,5-41.4h64.4l-9.9-26.2a9.87,9.87,0,0,1,11.8-13l32.6,8.6A17.14,17.14,0,0,1,1494.1,749.5Z",
    fill: "#ffcf2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1492.3,801.1a17.49,17.49,0,0,1-8.2,14.8l-30.2,19",
    fill: "none",
    stroke: "#73325a",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1492.3,773.4a17.49,17.49,0,0,1-8.2,14.8l-30.2,19",
    fill: "none",
    stroke: "#73325a",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1492.3,747.4a17.49,17.49,0,0,1-8.2,14.8l-30.2,19",
    fill: "none",
    stroke: "#73325a",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1461.8,
    y1: 753.8,
    x2: 1446.7,
    y2: 763.2,
    fill: "none",
    stroke: "#73325a",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1428.3,804.6c0,21.6-3.6,40.9-9.3,53.6h-32.3c-5.7-12.7-9.3-32-9.3-53.6a162.94,162.94,0,0,1,5-41.4h40.8C1426.4,774.7,1428.3,789.1,1428.3,804.6Z",
    fill: "#e57281"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1282.2,
    y1: 612.5,
    x2: 1210.3,
    y2: 733.6,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1402,733.6c-14,0-25.4,34.1-25.4,72.9s11.4,70.2,25.4,70.2H1241",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "RIGHT-2",
    "data-name": "RIGHT"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1576.5,315.6l94.8,117.7-53.8,54.6-119.1-93c-3.5-3.4-.7-12.4,6.5-23.6a165.44,165.44,0,0,1,21.8-26.7,169,169,0,0,1,26.4-22.2C1564.1,315.2,1573,312.3,1576.5,315.6Z",
    fill: "#3fb1b5",
    stroke: "#3fb1b5",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1644.23,
    cy: 460.81,
    rx: 38.3,
    ry: 14.3,
    transform: "translate(162.11 1308.86) rotate(-45.43)",
    fill: "#fff",
    stroke: "#3fb1b5",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1599.5,425.2v7.6c0,6.2-15.8,9.2-20.1,4.7L1542,398.3a16.12,16.12,0,0,1-4.4-11V364.7a18.42,18.42,0,0,1,7.3-14.7l13.3-10.1a18.26,18.26,0,0,1,11.2-3.8h36.1a26.83,26.83,0,0,1,23.8,14.3l31.8,59.9h-46.9A14.9,14.9,0,0,0,1599.5,425.2Z",
    fill: "#ffcf2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1660.4,410.4h-45.1a14.94,14.94,0,0,0-14.9,14.9v7.6c0,6.2-14,9.2-18.3,4.7l-41.5-43.2",
    fill: "none",
    stroke: "#73325a",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1555.9,410.4a15.3,15.3,0,0,1-4.3-10.7v-22a18,18,0,0,1,7.1-14.4l13-9.9a18.22,18.22,0,0,1,11-3.7h25.4",
    fill: "none",
    stroke: "#73325a",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1570.3,425.6a15.3,15.3,0,0,1-4.3-10.7v-22a18,18,0,0,1,7.1-14.4l13-9.9a18.22,18.22,0,0,1,11-3.7h22.7",
    fill: "none",
    stroke: "#73325a",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1586,438.2a14.17,14.17,0,0,1-4-9.9V407.9a16.53,16.53,0,0,1,6.6-13.3l12-9.2a16.83,16.83,0,0,1,10.1-3.4h15.2",
    fill: "none",
    stroke: "#73325a",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })))), /*#__PURE__*/React.createElement("g", {
    id: "_2_CHARACTER",
    "data-name": "2 CHARACTER"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SHIRT"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2359.8,1187.6h391.8a240.19,240.19,0,0,1,198,104.2l179.5,264.4c14.8,21.5,1.4,50.8-24.7,50.8H2904.6l-79.8-104.3c-9.4-13.2-30.2-7.4-31.5,8.8l-16.1,196.4H2349.9l-36-199.7c-2.2-15.6-22.4-20.4-31.5-7.5l-73.3,94.4H1970.2l186.4-295.4A240.41,240.41,0,0,1,2359.8,1187.6Z",
    fill: "#fff",
    stroke: "#3fb1b5",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2598.5 1289.6 2662 1500.5 2505.1 1500.5 2574.8 1289.6 2598.5 1289.6",
    fill: "#fe5244"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "2547.9 1371.1 2547.9 1500.5 2543.7 1500.5 2543.7 1383.8 2543.7 1383.8 2545.1 1379.5 2547.9 1371.1",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2588.4,
    y: 1290.1,
    width: 4.2,
    height: 210.4,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2637.3 1418.4 2637.3 1500.5 2633.1 1500.5 2633.1 1404.4 2637.3 1418.4",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2653.8 1473.2 2514.1 1473.2 2515.5 1468.9 2652.5 1468.9 2653.8 1473.2",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2640.3 1428.5 2528.9 1428.5 2530.3 1424.2 2639 1424.2 2640.3 1428.5",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2626.9 1383.8 2543.7 1383.8 2545.1 1379.5 2625.6 1379.5 2626.9 1383.8",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2613.4 1339.1 2558.5 1339.1 2559.9 1334.8 2612.1 1334.8 2613.4 1339.1",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2599.9 1294.4 2573.3 1294.4 2574.7 1290.1 2598.7 1290.1 2599.9 1294.4",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "2626.9 1287.4 2652.5 1314.9 2735 1187.6 2661.9 1187.6 2626.9 1287.4",
    fill: "#fff",
    stroke: "#3fb1b5",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2551 1287.4 2525.3 1314.9 2435.9 1187.6 2515.9 1187.6 2551 1287.4",
    fill: "#fff",
    stroke: "#3fb1b5",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "HAND"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3160.5,1631.2c0,49.8-35.5,97-90.7,105.1l-226.3,33.3-49.7,7.3V1584.5l15.3-3.6,220.8-52.4a105.94,105.94,0,0,1,111.8,43.1A103.93,103.93,0,0,1,3160.5,1631.2Z",
    fill: "#a0505a"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2843.5 1769.6 2793.8 1776.9 2793.8 1584.5 2809.1 1580.9 2843.5 1769.6",
    fill: "#73325a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LAPTOP"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2793.8,1826.1H2318.1V1540.6a40.1,40.1,0,0,1,40.1-40.1h395.4a40.1,40.1,0,0,1,40.1,40.1v285.5Z",
    fill: "#ffcf2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2585.3,1686.1h-58.7a10.76,10.76,0,0,1-10.8-10.8v-24.6a10.76,10.76,0,0,1,10.8-10.8h58.7a10.76,10.76,0,0,1,10.8,10.8v24.6A10.82,10.82,0,0,1,2585.3,1686.1Z",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "LEGS-2",
    "data-name": "LEGS"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RIGHT-3",
    "data-name": "RIGHT"
  }, /*#__PURE__*/React.createElement("path", {
    id: "LEG",
    d: "M2485.2,1823l503.6-75.3c98-14.9,186.3,61,186.3,160.2h0a162,162,0,0,1-162,162H2488.5Z",
    fill: "#0096a0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SHOES"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2417.1,2114,2114,2172.5c-38.6,8.2-77.4-24-79.1-65.6l-4.5-110.6c-2.3-56,51.4-89.7,102-65.7Z",
    fill: "#fff",
    stroke: "#fe5244",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2134.5,2168.5c-37.3,7.8-75-23.5-76.8-64l-4.7-107.4c-2.4-54.4,49.4-86.8,98.4-63.4",
    fill: "none",
    stroke: "#fe5244",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2132.4 1930.5 2417.1 2114 2352.2 2126.5 2132.4 1930.5",
    fill: "#fe5244"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "2242.1 2010.9 2204.6 2085.6 2167.5 1997.8 2124.6 2096.4",
    fill: "none",
    stroke: "#fe5244",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "2122.5 1984.1 2164.5 2088.9 2205.6 2005.2 2237.5 2075",
    fill: "none",
    stroke: "#fe5244",
    strokeLinejoin: "round",
    strokeWidth: 6
  }))), /*#__PURE__*/React.createElement("g", {
    id: "LEFT-3",
    "data-name": "LEFT"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LEG-2",
    "data-name": "LEG"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2652.5,1976.9c-16.8-13.8-65.4,17.6-108.6,70.1s-64.6,106.3-47.8,120.1c-2.5-1.5-318.2-199.5-514.1-334.6a175.82,175.82,0,0,1-36.8-255.6c66.4-81.9,189.4-87.4,262.9-11.8Z",
    fill: "#3fb1b5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2574.17,
    cy: 2071.92,
    rx: 123.1,
    ry: 39.4,
    transform: "translate(-661.2 2743.89) rotate(-50.56)",
    fill: "#fe5244",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "SHOES-2",
    "data-name": "SHOES"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2791.5,2149.7l-56.2,95.4c-28.5,48.3-92.9,49.2-122.4,1.6l-94.6-152.4a357.22,357.22,0,0,1,29.6-41.4c20.8-25.3,42.9-45.7,62.1-58.5l150.6,57.3C2797.4,2065.8,2812.6,2113.8,2791.5,2149.7Z",
    fill: "#fff",
    stroke: "#fe5244",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2744.7,2045.5c34.8,13.5,47.1,58.6,27.2,93.1l-53,91.5c-26.8,46.4-87.5,47.2-115.4,1.6",
    fill: "none",
    stroke: "#fe5244",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "2559.9 2094.4 2636.5 2055.6 2613.5 2147.9 2705.1 2091.7",
    fill: "none",
    stroke: "#fe5244",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "2642.6 2184.9 2666.4 2077.4 2588.3 2115.9 2600.3 2044.5",
    fill: "none",
    stroke: "#fe5244",
    strokeLinejoin: "round",
    strokeWidth: 6
  })))), /*#__PURE__*/React.createElement("g", {
    id: "HEAD-3",
    "data-name": "HEAD"
  }, /*#__PURE__*/React.createElement("path", {
    id: "HEAD-4",
    "data-name": "HEAD",
    d: "M2702.3,1204.9a24.29,24.29,0,0,1-24.2,22.8H2656l-1.4,23.3c-1.2,19.2-20.3,38.8-40.2,38.8h-55.9c-19.8,0-39-19.6-40.2-38.8l-1.4-23.3h-22.4a24.28,24.28,0,0,1-24.2-22.9c-.8-14,10.7-25.6,24.7-25.6h18.9l-2.1-35.5a13,13,0,0,1,13-13.8h123.4a13,13,0,0,1,13,13.8l-2.1,35.5h19.1A24.36,24.36,0,0,1,2702.3,1204.9Z",
    fill: "#a0505a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "HAIR-2",
    "data-name": "HAIR",
    d: "M2659,1179.2h20.1s19.2-69.7.7-87.6-132.1-59.1-168.8-33.4c-26.8,18.8-12.2,121-12.2,121h14.8s59.7-42.8,69.1-39.1-27,21.7-19.7,25.2c27.3,13.1,76.4-34.4,87.7-34.4S2659,1179.2,2659,1179.2Z",
    fill: "#73325a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "FACE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2633.7,1196.5s-13.1-10.6-29.9-3.7",
    fill: "none",
    stroke: "#73325a",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2606.9,1253.5s-7.2,15.4-29,7.4",
    fill: "none",
    stroke: "#73325a",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2534.1,1193s26.5-5.9,34.5,10.5c4.9,10.1,2.5,45.4,8.2,45.8s14.3,0,14.3,0",
    fill: "none",
    stroke: "#73325a",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2615.8,
    cy: 1215.9,
    rx: 4.7,
    ry: 7.8,
    fill: "#73325a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2555,
    cy: 1215.9,
    rx: 4.7,
    ry: 7.8,
    fill: "#73325a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2509,1208.5a18.52,18.52,0,0,0-18.5-17.4",
    fill: "none",
    stroke: "#73325a",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2662.5,1209a19.6,19.6,0,0,1,19.5-18.5",
    fill: "none",
    stroke: "#73325a",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })))), /*#__PURE__*/React.createElement("g", {
    id: "_1_CHARACTER",
    "data-name": "1 CHARACTER"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HEAD-5",
    "data-name": "HEAD"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HAIR-3",
    "data-name": "HAIR"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1184,1402.6c0-6.5-.3-12.8-.8-18.7-6.1-2.7-44.6-21.2-54.3-54.5,0,0-29.2,59.1-72.6,52.3a.37.37,0,0,1-.3-.1h-.1l-10.5-5.4c-.2-.1-.3-.2-.5-.2a19.86,19.86,0,0,0-28,14.1,123.14,123.14,0,0,1-6-24.8c-7.7-58.2,24.4-106.9,77.7-106.9,48.6,0,95.3,45.7,102.7,94A82.86,82.86,0,0,1,1184,1402.6Z",
    fill: "#ffcf2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.5,1409.6c-4.7,27.6-107.7-10.9-130.6,35.2-14.9,30.1,8.1,66.4-56.6,69.5-77.1,3.6-108.4,45.8-95.9,143.6L953,1546.2l58.8-52.4,25.6-78.7Z",
    fill: "#ffcf2d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "NECK-2",
    "data-name": "NECK"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "1145.5 1474.6 1145.5 1502 1080.4 1541.4 1011.8 1493.9 1037.4 1415.2 1145.5 1474.6",
    fill: "#e57281"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1049.2 1421.4 1080.4 1541.4 1145.5 1502 1145.5 1474.6 1049.2 1421.4",
    fill: "#9a3b82"
  })), /*#__PURE__*/React.createElement("g", {
    id: "HEAD-6",
    "data-name": "HEAD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1184,1403.2c0,44.7-28.7,81-64.1,81-29,0-54.7-24.3-63.1-57.7l-29.3-15a19.86,19.86,0,0,1-7.9-7.3,19.28,19.28,0,0,1-2.9-10.3,19.78,19.78,0,0,1,28.8-17.6l10.9,5.5v-.1c43.4,6.7,72.6-52.3,72.6-52.3,9.7,33.3,48.2,51.7,54.3,54.5C1183.8,1390,1184,1396.4,1184,1403.2Z",
    fill: "#e57281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1183.8,1393.9s-16.1-6.7-26,3.3c-12.3,12.4-9.6,48-9.6,48",
    fill: "none",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1126,1391.8a53.94,53.94,0,0,0-26.5,6",
    fill: "none",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047.3,1401.7a17.81,17.81,0,0,0-12.3-14",
    fill: "none",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1117.09,
    cy: 1414.67,
    rx: 7.8,
    ry: 4.7,
    transform: "translate(-540.54 2122.79) rotate(-74.84)",
    fill: "#9a3b82"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1166.09,
    cy: 1416.67,
    rx: 7.8,
    ry: 4.7,
    transform: "translate(-506.29 2171.56) rotate(-74.84)",
    fill: "#9a3b82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1143.3,1457.2s-17.3,4.6-22.3-10",
    fill: "none",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "BLOUSE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M883.8,1546.5h389.5a135,135,0,0,1,123.5,80.4l73.6,151.4L809.7,2098.2,596.8,2007l115.9-339.2A181.38,181.38,0,0,1,883.8,1546.5Z",
    fill: "#fff",
    stroke: "#fe5244",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1066.4 1613.3 1034.1 1594.2 1078.9 1543.2 1082.1 1543.2 1127.5 1590.8 1096 1609.9 1231.2 1888.5 974.5 2014 1066.4 1613.3",
    fill: "#fe5244"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "1012.8 1847 1012.8 1960.4 1008.8 1960.4 1008.8 1864.4 1012.8 1847",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1054.9 1663.1 1054.9 1960.3 1050.9 1960.3 1050.9 1680.5 1053.4 1669.7 1054.3 1665.7 1054.9 1663.1",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1054.9 1570.4 1054.9 1606.5 1050.9 1604.2 1050.9 1575 1054.9 1570.4",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1097.1 1559 1097.1 1954.1 1093.1 1956 1093.1 1554.8 1097.1 1559",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1139.3 1699.1 1139.3 1933.4 1135.3 1935.4 1135.3 1690.9 1139.3 1699.1",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1181.5 1786 1181.5 1912.8 1177.5 1914.8 1177.5 1777.7 1181.5 1786",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1223.6 1872.9 1223.6 1892.2 1219.6 1894.1 1219.6 1864.7 1223.6 1872.9",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1083.2 1960.9 1075 1964.9 985.8 1964.9 986.7 1960.9 1083.2 1960.9",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1169.4 1918.7 1161.2 1922.7 995.4 1922.7 996.4 1918.7 1169.4 1918.7",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1227.3 1880.5 1005.1 1880.5 1006 1876.5 1225.4 1876.5 1227.3 1880.5",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1206.9 1838.4 1014.8 1838.4 1015.7 1834.4 1204.9 1834.4 1206.9 1838.4",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1186.4 1796.2 1024.4 1796.2 1025.4 1792.2 1184.5 1792.2 1186.4 1796.2",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1165.9 1754 1034.1 1754 1035 1750 1164 1750 1165.9 1754",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1145.5 1711.9 1043.8 1711.9 1044.7 1707.9 1143.5 1707.9 1145.5 1711.9",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1125 1669.7 1053.4 1669.7 1054.3 1665.7 1123.1 1665.7 1125 1669.7",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1104.6 1627.5 1063.1 1627.5 1064 1623.5 1102.6 1623.5 1104.6 1627.5",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1122.3 1585.4 1041.8 1585.4 1045.3 1581.4 1118.5 1581.4 1122.3 1585.4",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 869.9,
    y1: 1763.5,
    x2: 838.5,
    y2: 1869.5,
    fill: "none",
    stroke: "#fe5244",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1200.5 1546.3 1126.4 1588.7 1082.1 1543.2 1078.9 1543.2 1035.1 1592.2 953 1546.3 1012.8 1493.9 1080.4 1541.4 1145.5 1502 1200.5 1546.3",
    fill: "#fff",
    stroke: "#fe5244",
    strokeLinejoin: "round",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "BOOK"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "1597.1 1670.5 1519.5 1917.1 1047.5 1917.1 1125.1 1670.5 1597.1 1670.5",
    fill: "#3fb1b5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1298.5,
    y1: 1917.1,
    x2: 1376.1,
    y2: 1670.5,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1134,1670.5s59.1-35.1,144.7-29.7,97.6,29.7,97.6,29.7Z",
    fill: "#fff",
    stroke: "#3fb1b5",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1580,1670.5s-111.4-49.2-203.7,0Z",
    fill: "#fff",
    stroke: "#3fb1b5",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "LEGS-3",
    "data-name": "LEGS"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RIGHT-4",
    "data-name": "RIGHT"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1364,2174.9l-229.4,181.2a60.71,60.71,0,0,0-7.9,87.9l157.6,178.8s15-11.1,10-55.7c-7-61.7,10-119.4,10-119.4l339.5-242.1a202.53,202.53,0,0,0,85-162.1h0c1.3-87.6-104.9-132-166.4-69.7Z",
    fill: "#e57281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1304.2,2447.6s-16.9,57.7-10,119.4c5,44.7-10,55.8-10,55.8L1126.6,2444a60.79,60.79,0,0,1,7.9-87.9l73.6-58.2c2.2-1.6,4.4-3.3,6.6-5l93.6-74,55.6-44s-3.1,73.1,31.3,207.8Z",
    fill: "#fff",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1297.9,2573c1.9,17.3.7,29.8-1.6,38.6a36.87,36.87,0,0,1-1.8,5.6c-3.9,10.3-9,13.7-9,13.7l-163.4-185.3a63,63,0,0,1-.3-82.9,61.06,61.06,0,0,1,8.6-8.2l5.3-4.2,46-36.3c-3,20,9.9,53.5,34.7,85.1,31.4,40,73.1,61.3,91.3,50.3C1304.8,2460,1291.5,2515.9,1297.9,2573Z",
    fill: "#ffcf2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1296.4,2611.6a36.87,36.87,0,0,1-1.8,5.6l-162.2-184a65,65,0,0,1-16.1-49.2,67,67,0,0,1,5.6-21.4,61.06,61.06,0,0,1,8.6-8.2l5.3-4.2a59.3,59.3,0,0,0-14.5,34.2,60.15,60.15,0,0,0,14.9,45.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1301.1,2479.8s-44-17.5-49.9,0,46.6,28.6,46.6,28.6Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LEFT-4",
    "data-name": "LEFT"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1582,1937.6v547.9c-63.7,64.7-148.3,29.9-148.3,29.9C1359,2300.4,1364,2181,1364,2181l-55.6,43.9c-142.2-88.8-153.8-293.1-154.1-298L1386,1814.8C1476.7,1770.9,1582,1836.9,1582,1937.6Z",
    fill: "#e57281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1386.1,1814.7c90.6-43.8,195.9,22.2,195.9,122.8v547.9c-63.7,64.7-148.3,29.9-148.3,29.9-74.6-215-69.7-334.5-69.7-334.5",
    fill: "none",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "SKIRT"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1308.4,2224.8l-93.6,74C1047,2431.5,800.2,2312,800.2,2098.1h0l354.1-171.4v.1C1154.6,1931.8,1166.3,2136.1,1308.4,2224.8Z",
    fill: "#fe5244"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M844.4,2076.8v166.1c-1.4-2-2.7-4-4-6V2078.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.6,2056.4v233.7c-1.3-1.2-2.7-2.4-4-3.6V2058.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M928.7,2036v284.1c-1.3-.8-2.7-1.5-4-2.3V2037.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.9,2015.6v323.9c-1.3-.5-2.7-.9-4-1.4V2017.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.1,1995.2v355.5c-1.3-.2-2.7-.5-4-.7V1997.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055.2,1974.7v379.8c-1.3,0-2.7,0-4-.1V1976.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1097.4,1954.3v397l-4,.6V1956.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1139.6,1933.9v406.7c-1.3.5-2.7.9-4,1.4V1935.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1181.7,2054.8v266.5c-1.3.8-2.7,1.5-4,2.2V2043.1a11.76,11.76,0,0,0,.7,2c.4,1.3.9,2.7,1.3,4C1180.4,2051,1181.1,2052.9,1181.7,2054.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1223.9,2140.8v150.9l-4,3.2V2134.6C1221.2,2136.6,1222.5,2138.7,1223.9,2140.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1266.1,2191.8V2260H1264l-1.9,1.5v-73.7C1263.4,2189.2,1264.7,2190.5,1266.1,2191.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1140.3,2340.3c-.3.1-.5.2-.8.3-1.3.5-2.7.9-4,1.4-2.5.8-5,1.6-7.6,2.4H985.7c-4.2-1.2-8.4-2.6-12.6-4h167.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1215.7,2298.1l-.9.7-4.2,3.3H901.4c-1.8-1.3-3.5-2.6-5.2-4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1269,2256l-3,2.3v1.7H857.2c-1.1-1.3-2.2-2.7-3.2-4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1297.8,2217.8H829.3c-.7-1.3-1.4-2.7-2.1-4h465C1294,2215.2,1295.9,2216.5,1297.8,2217.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.6,2175.6H811.8c-.4-1.3-.8-2.7-1.2-4h436.6A42.34,42.34,0,0,0,1250.6,2175.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1219.2,2133.5H802.5c-.2-1.3-.3-2.7-.5-4h414.7C1217.6,2130.8,1218.4,2132.1,1219.2,2133.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1196.6,2091.3H814.5l8.3-4h372A35.19,35.19,0,0,0,1196.6,2091.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1179.8,2049.1H901.6l8.3-4h268.6A26.71,26.71,0,0,0,1179.8,2049.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1167.4,2007H988.6l8.3-4h169.5C1166.8,2004.3,1167.1,2005.6,1167.4,2007Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1158.8,1964.8h-83.1l8.3-4h74.2C1158.4,1962.1,1158.6,1963.4,1158.8,1964.8Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1154.3,1926.8h0c.3,5,11.9,209.3,154.1,298.1",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1582,2289.7v195.8c-63.7,64.7-148.3,29.9-148.3,29.9-32.7-94.2-50.1-170.1-59.4-225.6H1582Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1433.6,2515.3c-32.7-94.2-50.1-170.1-59.4-225.6h207.7v195.8",
    fill: "none",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1731.3,2628.8H1435.8a22.34,22.34,0,0,1-22.1-25.9l.5-3,1.8-10.8,12.8-78.4s90.1,36.3,156.5-31.1c0,0,20.8,53.6,107.6,93,20.4,9.3,30,23.1,34.5,34.8.7,1.7,1.2,3.4,1.7,5A52.08,52.08,0,0,1,1731.3,2628.8Z",
    fill: "#ffcf2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1729.1,2612.3H1435.8a24.62,24.62,0,0,1-18.9-8.8,22.55,22.55,0,0,1-2.6-3.7l1.8-10.8a19.31,19.31,0,0,0,4.7,11.3,20,20,0,0,0,15.1,7h291.6C1728.1,2609,1728.7,2610.7,1729.1,2612.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1631.1,2535.1c-32.8,23.4-83.3,16.7-86.7,6.6s48.9-17.3,55.8-38.1A194,194,0,0,0,1631.1,2535.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1364,2180.9c0-117.5,31-185.7,31-185.7",
    fill: "none",
    stroke: "#9a3b82",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }))), /*#__PURE__*/React.createElement("g", {
    id: "HAND-2",
    "data-name": "HAND"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1080.4,1812.6,670,1909.1a115,115,0,0,0-88.7,112h0c0,84.9,88.9,140.6,165.3,103.5l397.1-192.8a29.94,29.94,0,0,0,14.9-16.2l44-112.9a6.37,6.37,0,0,0-6.9-8.6l-7,1a41,41,0,0,0-27.6,16.9l-17.9,26.8a17.68,17.68,0,0,1-14.7,7.8h-41.9a12.59,12.59,0,0,1-12-16.4Z",
    fill: "#e57281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1076.4,1813.6,670,1910.1a115,115,0,0,0-88.7,112h0c0,84.9,88.9,140.6,165.3,103.5l397.1-192.8a29.94,29.94,0,0,0,14.9-16.2l44-112.9a6.37,6.37,0,0,0-6.9-8.6l-7,1a41,41,0,0,0-27.6,16.9l-17.9,26.8a17.68,17.68,0,0,1-14.7,7.8h-45.9a12.59,12.59,0,0,1-12-16.4Z",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.6,1879.6h61.3a27.58,27.58,0,0,0,24.2-14.4",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1078.6,1915.6h61.3a27.58,27.58,0,0,0,24.2-14.4",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiDestination);
export default __webpack_public_path__ + "static/media/aiDestination.1a0d5d794f5aaaaa1951aab093480b73.svg";
export { ForwardRef as ReactComponent };